// Flow Data Schema
export const DEPARTMENTS = {
    retail: {
        name: 'Retail',
        categories: [
            { id: 'point_of_sale', name: 'Point of Sale', department: 'retail' },
            { id: 'inventory', name: 'Inventory Management', department: 'retail' },
            { id: 'activations', name: 'Customer Activations', department: 'retail' },
            { id: 'store_ops', name: 'Store Operations', department: 'retail' },
        ],
    },
    call_center: {
        name: 'Call Center',
        categories: [
            { id: 'account_mgmt', name: 'Account Management', department: 'call_center' },
            { id: 'billing', name: 'Billing & Payments', department: 'call_center' },
            { id: 'tech_support', name: 'Technical Support', department: 'call_center' },
            { id: 'escalations', name: 'Escalations', department: 'call_center' },
        ],
    },
    corporate: {
        name: 'Corporate',
        categories: [
            { id: 'hr_systems', name: 'HR Systems', department: 'corporate' },
            { id: 'finance', name: 'Finance Tools', department: 'corporate' },
            { id: 'internal', name: 'Internal Processes', department: 'corporate' },
        ],
    },
};
/** Events shown as primary steps in the flow viewer (sidebar / progress). */
export function isViewerStepEvent(event) {
    switch (event.type) {
        case 'navigation':
        case 'click':
        case 'input':
        case 'select':
        case 'submit':
        case 'modal':
            return true;
        default:
            return false;
    }
}
/**
 * Indexes into `events` that the viewer treats as steps. Falls back to all
 * indexes when no event matches {@link isViewerStepEvent} (legacy flows).
 */
export function getViewerStepEventIndexes(events) {
    const preferred = events.reduce((acc, event, index) => {
        if (isViewerStepEvent(event)) {
            acc.push(index);
        }
        return acc;
    }, []);
    return preferred.length > 0 ? preferred : events.map((_event, index) => index);
}
